import * as React from 'react';
import { IJobSearchPageContent } from '../models/content';
import { IDropdownOption, Dropdown } from '../../global/components/dropdown';


interface IProps {
    content: IJobSearchPageContent;
    onCityChange: (value: string) => void;
    onBusinessAreaChange: (value: string) => void;
    onCountryChange: (value: string) => void;
    onStateChange: (value: string) => void;
    countries: string[];
    states: string[];
    cities: string[];
    businessAreas: string[];
    selectedBusinessArea: string;
    selectedCity: string;
    selectedCountry: string;
    selectedState: string;
}

export class JobSearchFilters extends React.Component<IProps, any> {
    render() {
        var { countries, states, cities, businessAreas, onCityChange, onBusinessAreaChange, onCountryChange, onStateChange, content, selectedState, selectedCountry, selectedCity, selectedBusinessArea } = this.props;

        return (
            <div className="filter-container">
                <div className="filter-inner theme-dark-solid">
                    <div className="filter-heading-container">
                        <h3 className="h6-style filter-heading">{content.filterLabelText}</h3>
                    </div>
                    <ul className="filter-list no-bullets">
                        <li className="filter-item">
                            <label htmlFor="ddlCountry" className="small">{content.countryFilterLabelText}</label>
                            <Dropdown
                                onDropdownSelect={onCountryChange}
                                placeHolder={content.countryFilterPlaceholderText}
                                selectedId={selectedCountry}
                                id={"ddlCountry"}
                                cssClass="filter-dropdown"
                                values={countries ? countries.map(x => {
                                    return Object.freeze({
                                        id: x,
                                        display: x
                                    }) as IDropdownOption
                                }) : []}
                            />
                        </li>
                        <li className="filter-item">
                            <label htmlFor="ddlState" className="small">{content.stateFilterLabelText}</label>
                            <Dropdown
                                onDropdownSelect={onStateChange}
                                placeHolder={content.stateFilterPlaceholderText}
                                selectedId={selectedState}
                                id={"ddlState"}
                                cssClass="filter-dropdown"
                                values={states ? states.map(x => {
                                    return Object.freeze({
                                        id: x,
                                        display: x
                                    }) as IDropdownOption
                                }) : []}
                            />
                        </li>
                        <li className="filter-item">
                            <label htmlFor="ddlCity" className="small">{content.cityFilterLabelText}</label>
                            <Dropdown
                                onDropdownSelect={onCityChange}
                                placeHolder={content.cityFilterPlaceholderText}
                                selectedId={selectedCity}
                                id={"ddlCity"}
                                cssClass="filter-dropdown"
                                values={cities ? cities.map(x => {
                                    return Object.freeze({
                                        id: x,
                                        display: x
                                    }) as IDropdownOption
                                }) : []}
                            />
                        </li>
                        <li className="filter-item">
                            <label htmlFor="ddlBusinessArea" className="small">{content.businessAreaFilterLabelText}</label>
                            <Dropdown
                                onDropdownSelect={onBusinessAreaChange}
                                placeHolder={content.businessAreaFilterPlaceholderText}
                                selectedId={selectedBusinessArea}
                                id={"ddlBusinessArea"}
                                cssClass="filter-dropdown"
                                values={businessAreas ? businessAreas.map(x => {
                                    return Object.freeze({
                                        id: x,
                                        display: x
                                    }) as IDropdownOption
                                }) : []}
                            />
                        </li>
                    </ul>
                </div>
            </div>
        )
    }
}